import "./style.css";
import SpanishTerms from "./SpanishTerms";
import EnglishTerms from "./EnglishTerms";

const TermsAndConditions = () => {
  return (
    <div className="mb-5 pb-5 d-flex flex-column gap-5" id="blog">
      <div
        className="img-fluid"
        style={{
          position: "relative",
          paddingTop: "5em",
          paddingBottom: "5em",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundColor: "#0C265F",
        }}
      >
        <div className="container">
          <h1
            className="beba-font text-white text-center"
            style={{ textDecoration: "none" }}
          >
            Términos y Condiciones
          </h1>
          <p className="text-white text-center fw-light">
            Si necesitas ayuda, no dudes en comunicarte con nosotros y
            gestionaremos el proceso.
          </p>
          <div className="d-flex flex-column flex-md-row justify-content-center gap-3 mt-4">
            <a
              href="mailto:info@puertoricocartransfer.com"
              className="btn btn-primary"
            >
              Envianos un correo
            </a>
            <a href="tel:+17877416032" className="btn btn-outline">
              <i className="bi bi-telephone-fill me-2"></i> (1) 787-741-6032
            </a>
          </div>
        </div>
      </div>
      <SpanishTerms />
      <EnglishTerms />
    </div>
  );
};

export default TermsAndConditions;
